/* ame-pdp-zones.js — presentation glue for the three-zone product page (2026-10-16 PDP visual reconstruction).
   Owns NO commerce state: pricing, selection dependencies, cart assembly and checkout stay in ame-pdp-state.js. This file
   only (1) rewrites model-specific specification values when the selected variant changes (brief §6), (2) keeps the
   hitch guidance line factual for the selected model (brief §3/§8 — manufacturer requirement vs the receiver the shopper
   named; never a compatibility verdict), (3) names the selected model in the order summary header, and (4) lets the
   order summary stick on desktop ONLY while it fits under the header (brief §3 B). */
(function () {
  var specs = {}, pdp = {};
  var island = document.getElementById('ame-variant-specs');
  try { specs = island ? JSON.parse(island.textContent) : {}; } catch (e) { specs = {}; }
  var dataIsland = document.querySelector('[data-ame-pdp-data]');
  try { pdp = dataIsland ? JSON.parse(dataIsland.textContent) : {}; } catch (e) { pdp = {}; }
  var form = document.getElementById('ame-product-form');

  function vid() {
    var h = form && form.querySelector('[name="id"]');
    if (h && h.value) return String(h.value);
    return pdp.initialVariantId ? String(pdp.initialVariantId) : null;
  }
  function clean(v) { v = String(v == null ? '' : v).trim(); return /^\d+\.0$/.test(v) ? v.slice(0, -2) : v; }
  function classOf(txt) {
    var m = /class\s*(iv|iii|ii|i|[1-4])\b/i.exec(txt || '');
    if (!m) return 0;
    var roman = { i: 1, ii: 2, iii: 3, iv: 4 }, x = m[1].toLowerCase();
    return roman[x] || parseInt(x, 10) || 0;
  }

  /* ---- 1. model-specific values ---- */
  function applySpecs() {
    var id = vid(), s = (id && specs[id]) || null;
    if (s) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-vspec-key]'), function (el) {
        var k = el.getAttribute('data-vspec-key');
        if (s[k] == null) return;
        var t = clean(s[k]) + (el.getAttribute('data-vspec-unit') || '');
        if (el.textContent !== t) el.textContent = t;
      });
    }
    /* ---- 3. the selected model in the summary header ---- */
    var model = document.querySelector('[data-summary-model]');
    if (model && id) {
      var v = pdp.variants && pdp.variants[id];
      var name = (s && s.manufacturer_model) || (v && v.sku) || (v && v.title && v.title !== 'Default Title' ? v.title : '');
      if (name) {
        var vendor = model.getAttribute('data-summary-vendor') || '';
        var txt = (vendor && name.indexOf(vendor) !== 0 ? vendor + ' ' : '') + name;
        if (model.textContent !== txt) model.textContent = txt;
      }
    }
    fitNote(s || {});
  }

  /* ---- 2. hitch guidance: what the manufacturer lists for the selected model vs the receiver class the shopper named ---- */
  var note = document.querySelector('[data-fit-note]');
  function fitNote(s) {
    if (!note) return;
    var grp = note.getAttribute('data-fit-group');
    var checked = grp ? document.querySelector('input[name="' + grp + '"]:checked') : null;
    var sel = checked ? (checked.getAttribute('data-title') || '') : '';
    var min = classOf(s.hitch_class || ''), have = classOf(sel);
    var model = s.manufacturer_model || 'this model';
    var req = s.hitch_class ? ('a ' + s.hitch_class + ' hitch') : '';
    var inc = s.included_adapter ? ('The ' + s.included_adapter + ' is included.') : '';
    var txt = '', caution = false;
    if (!req) { txt = ''; }
    else if (have && min && have < min) {
      caution = true;
      txt = 'Harmar lists ' + req + ' for the ' + model + ' — a Class ' + have + ' receiver is below that rating. Call us before ordering so we can check your options.';
    } else if (have) {
      txt = 'Harmar lists ' + req + ' for the ' + model + '; a Class ' + have + ' receiver is within that range. ' + inc + ' We confirm every vehicle-lift order by phone before shipping.';
    } else if (/no hitch/i.test(sel)) {
      txt = 'Harmar lists ' + req + ' for the ' + model + '. A hitch receiver has to be installed on the vehicle before this lift can be fitted — call us and we can talk through the options. ' + inc;
    } else {
      txt = 'Harmar lists ' + req + ' for the ' + model + '. ' + inc + ' We confirm every vehicle-lift order by phone before shipping.';
    }
    txt = txt.replace(/\s+/g, ' ').trim();
    if (note.textContent !== txt) note.textContent = txt;
    note.hidden = !txt;
    note.classList.toggle('is-caution', caution);
  }

  document.addEventListener('ame:pdp:state', applySpecs);
  document.addEventListener('ame:variant-change', applySpecs);
  document.addEventListener('change', function (e) {
    if (note && e.target && e.target.name && e.target.name === note.getAttribute('data-fit-group')) fitNote(specs[vid()] || {});
  });
  applySpecs();

  /* ---- 4. the order summary sticks only while it fits under the sticky header; otherwise it scrolls like everything else ---- */
  var aside = document.querySelector('[data-customize-aside]');
  if (aside) {
    var mq = window.matchMedia('(min-width: 990px)');
    var fit = function () {
      var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ame-sticky-top')) || 0;
      var ok = mq.matches && (aside.offsetHeight + top + 32) <= window.innerHeight;
      aside.classList.toggle('is-sticky-ok', ok);
    };
    fit();
    window.addEventListener('resize', fit);
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(aside);
    document.addEventListener('ame:pdp:state', fit);
    if (mq.addEventListener) mq.addEventListener('change', fit);
  }
})();
